import { produce } from 'immer';
import { PREPARE_DOWNLOAD } from './types.js';

export const INITIAL_STATE = {
    preparingViewIds: new Set()
};

export const downloadViewReducer = produce((draft, action) => {
    switch (action.type) {
        case PREPARE_DOWNLOAD.STARTED:
            draft.preparingViewIds.add(action.meta.viewUuid);
            break;

        case PREPARE_DOWNLOAD.ENDED:
            draft.preparingViewIds.delete(action.meta.viewUuid);
            break;

        default:
    }
}, INITIAL_STATE);
